import { makeResolvedArtifactWrappers } from './makeResolvedArtifactWrappers';
import { useResolvedRuleName } from './useResolvedRuleName';
import { useResolvedSegmentName } from './useResolvedSegmentName';
import { useResolvedWorkflowName } from './useResolvedWorkflowName';

const workflow = makeResolvedArtifactWrappers(useResolvedWorkflowName);
const segment = makeResolvedArtifactWrappers(useResolvedSegmentName);
const rule = makeResolvedArtifactWrappers(useResolvedRuleName);

export const WorkflowArtifactListItem = workflow.ListItem;
export const SegmentArtifactListItem = segment.ListItem;
export const RuleArtifactListItem = rule.ListItem;
